export default __webpack_public_path__ + "static/media/agrovar-logo.56bea895.svg";